

function nameMatches(errorName, fieldName) {
    return errorName === fieldName
        || errorName?.startsWith(`${fieldName}.`);
}

export function fieldErrors(errors, name) {
    return Object.entries(errors ?? {})
        .filter(([errorName, errors]) => nameMatches(errorName, name))
        .map(([errorName, errors]) => errors)
        .flat();
}

export function fieldError(errors, name) {
    const filteredErrors = fieldErrors(errors, name);
    return filteredErrors[0];
}

export function fieldNameAttribute(name) {
    return name?.replace(/\.([^.]+)/g, '[$1]');
}

export function errorsExcept(errors, name) {
    return Object.fromEntries(
        Object.entries(errors ?? {})
            .filter(([errorName, errors]) => !nameMatches(errorName, name))
    );
}
